import React from 'react';

export interface DynamicLoaderLoaderProps {
    url: string;
    type?: string;
    onLoad?: () => void;
}

const DynamicLoader = (props: DynamicLoaderLoaderProps) => {

    const { url, onLoad, type: _type } = props;
    const type = _type ?? (url.endsWith(".js") || url.includes(".js?") ? "script" : "style");

    React.useEffect(() => {
        const link = document.createElement(type);
        if (type === "style") {
            (link as HTMLLinkElement).href = url;
            (link as HTMLLinkElement).type = 'text/css';
            (link as HTMLLinkElement).rel = 'stylesheet';
        } else {
            (link as HTMLScriptElement).src = url;
        }
        link.onload = () => onLoad?.();
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [url]);

    return null;
};

export default DynamicLoader;